import { render, staticRenderFns } from "./insertvideo.vue?vue&type=template&id=3618b94d&scoped=true&"
import script from "./insertvideo.vue?vue&type=script&lang=js&"
export * from "./insertvideo.vue?vue&type=script&lang=js&"
import style0 from "./insertvideo.vue?vue&type=style&index=0&id=3618b94d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3618b94d",
  null
  
)

export default component.exports